/** True when report month is January (YYYY-01). */
export function isJanuaryReportMonth(reportMonth: string): boolean {
  return /^\d{4}-01$/.test(reportMonth)
}

export const PAC_PRIOR_YEAR_CLOSE_CHECK_ID = 'pac_prior_year_close_posted'

export function isPacPriorYearCloseChecked(
  items: { id: string; checked: boolean }[],
): boolean {
  return items.some((item) => item.id === PAC_PRIOR_YEAR_CLOSE_CHECK_ID && item.checked)
}

/** Show the January PAC close panel once readiness is loaded (including after the close JE is posted). */
export function shouldShowPacYearEndClosePanel(
  reportMonth: string | null | undefined,
  pacPriorYearClosePosted: boolean | null,
): boolean {
  if (!reportMonth || !isJanuaryReportMonth(reportMonth)) return false
  return pacPriorYearClosePosted !== null
}
